module.exports = __webpack_public_path__ + "img/cwc_50_100.prt.292ad0fc.jpg";